import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import * as fas from '@fortawesome/pro-solid-svg-icons';

export function appIcons(library: FaIconLibrary) {

  const fasIcons = [
    fas.faUser,
    fas.faInfo,
    fas.faCheck,
    fas.faQuestion,
    fas.faExclamation,
    fas.faTriangleExclamation,
  ];

  library.addIcons(
    ...fasIcons
  );

}
